export const MAIL_TYPE_OPTIONS = [
  { label: 'All', value: '0' },
  { label: 'ของรางวัลหมดอายุ', value: 'reward_expired' },
  { label: 'ของรางวัลใกล้หมดอายุ (1 เดือน)', value: 'reward_near_expire' },
  { label: 'สรุปการตัดแต้มหมดอายุ', value: 'point_expired' },
];

export const MAIL_STATUS_OPTIONS = [
  { label: 'All', value: '0' },
  { label: 'สำเร็จ', value: 'success' },
  { label: 'ไม่สำเร็จ', value: 'fail' },
  { label: 'กำลังส่ง', value: 'sending' },
];

export const RENDER_MAIL_TYPE = (type) => {
  const found = MAIL_TYPE_OPTIONS.find((e) => e.value === type);
  return found && type !== '0' ? found.label : type || '-';
};

export const RENDER_MAIL_STATUS = (status) => {
  switch (status) {
    case 'success':
      return 'สำเร็จ';
    case 'fail':
      return 'ไม่สำเร็จ';
    case 'sending':
      return 'กำลังส่ง';
    default:
      return status || '-';
  }
};

export const RENDER_MAIL_TRIGGER = (trigger) => {
  switch (trigger) {
    case 'cron':
      return 'ระบบส่งอัตโนมัติ';
    case 'manual':
      return 'กดส่งจาก portal';
    case 'resend':
      return 'กดส่งซ้ำ';
    default:
      return trigger || '-';
  }
};

export const RENDER_REWARD_TYPE = (type) => {
  switch (type) {
    case '1':
      return 'E-coupon';
    case '2':
      return 'Coupon';
    case '3':
      return 'Others';
    default:
      return type || '-';
  }
};

// อธิบายสาเหตุที่พบบ่อยเป็นภาษาไทย ให้ดูแล้วรู้ว่าต้องแก้ตรงไหน
export const MAIL_ERROR_HINT = (log) => {
  if (!log) return '';
  const code = log.error_code;
  const responseCode = Number(log.error_response_code || 0);
  if (code === 'ESTALE') {
    return 'server API ถูก restart / ดับระหว่างส่ง ให้เช็คกล่องเมลผู้รับก่อน ถ้ายังไม่ได้รับค่อยกดส่งซ้ำ (รายการของรางวัลในเมลนี้จะถูกแจ้งใหม่ในรอบถัดไปอัตโนมัติ)';
  }
  if (code === 'EMAILCONFIG') {
    return 'ยังไม่ได้ตั้งค่า MAIL_USER / MAIL_PASS ในไฟล์ .env ของ API';
  }
  if (code === 'EAUTH' || responseCode === 535 || responseCode === 534) {
    return 'Gmail ไม่ยอมให้ login — รหัสแอพ (App Password) ผิด ถูกเพิกถอน หรือ account ถูกเปลี่ยนรหัสผ่าน ต้องสร้างรหัสแอพใหม่แล้วแก้ MAIL_PASS';
  }
  if (
    responseCode === 421 ||
    responseCode === 454 ||
    /quota|5\.4\.5|rate limit/i.test(log.error_response || '')
  ) {
    return 'Gmail จำกัดการส่งชั่วคราว (ส่งเยอะเกินโควต้า) ลองส่งซ้ำภายหลัง';
  }
  if (code === 'EENVELOPE' || responseCode === 550 || responseCode === 553) {
    return 'ที่อยู่อีเมลผู้รับ / ผู้ส่งไม่ถูกต้อง หรือถูกปฏิเสธ';
  }
  if (
    code === 'ECONNECTION' ||
    code === 'ETIMEDOUT' ||
    code === 'ESOCKET' ||
    code === 'EDNS'
  ) {
    return 'เชื่อมต่อ server ของ Gmail ไม่ได้ (เน็ต / firewall ของ server API) ลองส่งซ้ำภายหลัง';
  }
  if (log.status === 'success' && log.rejected && log.rejected.length > 0) {
    return 'Gmail รับเมลแล้ว แต่ปฏิเสธผู้รับบางราย ตรวจสอบที่อยู่อีเมลผู้รับ';
  }
  return '';
};
